import { render, staticRenderFns } from "./view-projects.vue?vue&type=template&id=3181d67e&scoped=true"
import script from "./view-projects.vue?vue&type=script&lang=js"
export * from "./view-projects.vue?vue&type=script&lang=js"
import style0 from "./view-projects.vue?vue&type=style&index=0&id=3181d67e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3181d67e",
  null
  
)

export default component.exports